import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { formatCurrency } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export function ProductQuickView({ product, open, onOpenChange }) {
  const { addToCart } = useStore();
  if (!product) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl overflow-hidden border-white/10 bg-void p-0 text-foreground" data-testid="product-quick-view-dialog">
        <div className="grid md:grid-cols-2">
          <div className="aspect-[4/5] bg-zinc-900 md:aspect-auto">
            <img src={product.image_url} alt={product.name} className="h-full w-full object-cover" />
          </div>
          <div className="p-8 md:p-10">
            <DialogHeader>
              <Badge className="mb-5 w-fit rounded-none bg-neon text-black hover:bg-neon">{product.category}</Badge>
              <DialogTitle className="font-heading text-4xl font-black italic tracking-tighter">{product.name}</DialogTitle>
              <DialogDescription className="pt-4 text-base leading-relaxed text-zinc-400">{product.description}</DialogDescription>
            </DialogHeader>
            <div className="mt-10 flex items-center justify-between border-y border-white/10 py-5">
              <span className="text-xs uppercase tracking-[0.24em] text-zinc-500">Price</span>
              <span data-testid="quick-view-price" className="font-subheading text-3xl font-bold text-volt">{formatCurrency(product.price)}</span>
            </div>
            <p data-testid="quick-view-stock" className="mt-5 text-sm text-zinc-500">{product.stock} pieces available</p>
            <Button data-testid="quick-view-add-button" onClick={() => addToCart(product)} disabled={product.stock === 0} className="kinetic-button mt-8 h-12 w-full rounded-none bg-volt font-bold uppercase tracking-[0.2em] text-black hover:bg-transparent hover:text-volt">
              Add to cart
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
